import { useEffect, useRef } from "react";

export const useOutsideClick = (onClose: () => void, exceptionTarget?: React.MutableRefObject<HTMLDivElement>) => {
  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      ref.current && !ref.current.contains(e.target as Node) && !exceptionTarget?.current?.contains(e.target as Node) && onClose();
    };

    document.addEventListener("mouseup", handleClick);

    return () => {
      document.removeEventListener("mouseup", handleClick);
    };
  }, [ref]);

  return ref;
};